import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import './style.scss';

const CustomProgressIndicator = ({ total = 0, completed = 0 }) => {
  const percentage = (completed / total) * 100;

  // Рассчитываем угол поворота для стрелки
  const rotateAngle = percentage * 2.52 - 90;

  return (
    <Box
      className="circular-progress-parrent-wrap"
      position="relative"
      display="inline-flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box className="circular-progress-wrap-box" position="relative">
        <Box className="circular-progress-first-wrap" position="relative">
          <CircularProgress
            className="circular-progress-first"
            variant="determinate"
            value={100}
            size={282}
            thickness={7.5}
            style={{
              color: 'rgba(228, 239, 255, 1)',
              transform: 'rotate(-90deg)',
            }}
          />
        </Box>

        <Box className="circular-progress-second-wrap" position="relative">
          <CircularProgress
            className="circular-progress-second"
            variant="determinate"
            value={percentage * 0.7} // Изменено здесь
            size={282}
            thickness={7.5}
            style={{
              color: 'rgba(169, 186, 245, 1)',
              transform: 'rotate(-90deg)',
            }}
          />
        </Box>

        <Box className="wrap-arrow" position="relative">
          <Box // Стрелка
            className="wrap-arrow-item"
            position="absolute"
            top="50%"
            left="50%"
            width="56px"
            height="56px"
            bgcolor="rgba(169, 186, 245, 1)"
            style={{
              transform: `translate(-50%, -50%) rotate(${rotateAngle}deg)`,
              zIndex: 2,
            }}
          ></Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomProgressIndicator;
